module.exports = "<p>invoices works!</p>\nGo to <a routerLink=\"/my-account\">My Account</a>\n"